<template>
	<b-form-group
		id="inputEmail"
		label=""
		label-for="Email"
	>
		<b-form-input
			id="email"
			:value="value"
			type="text"
			placeholder="E-mail"
			@input="getValue"
			:state="state"
			@change="$emit('change')"
			required
		></b-form-input>
		<b-form-invalid-feedback :state="state">
			{{ validationMessage }}
		</b-form-invalid-feedback>
	</b-form-group>
</template>

<script>
export default {
	nome: "InputEmail",
	props: {
		value: String,
		validationMessage: String
	},
	computed: {
		state() {
			if (this.validationMessage == null)
				return null

			return !this.validationMessage
		}
	},
	methods: {
		getValue(value) {
			this.$emit("input", value)
		}
	}
}
</script>